import React, { Component } from 'react';
import { Container } from "reactstrap";
import Arquitecto from './Arquitectos';
import Promotores from './Promotores';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Close from '@material-ui/icons/Close';
import { connect } from "react-redux";
import { postAddTrabajoEncomenda } from '../../actions/expedientes/index';

import { fetchErrorExpediente, formatMenssage } from '../../actions/expedientes/index';
import { withRouter } from 'react-router-dom';
import { Translate } from "react-localize-redux";
import {
  Dialog, DialogContent, DialogContentText, Typography, FormControlLabel, Checkbox,
  DialogActions, DialogTitle, CircularProgress
} from "@material-ui/core";
import ReactQuill from "react-quill";
import ApiCoag from "../../api/ApiCoag";
import Confirmation from "../Errors/confirmation";




class Agentes extends Component {
  constructor(props) {
    super(props);
    const initialArchitectSignatures = this.getArchitectSignatures(props.encomenda);
    const initialPromoterSignatures = this.getPromoterSignatures(props.encomenda);
    const hasExistingAgents = props.encomenda
      && props.encomenda.Colegiados
      && props.encomenda.Colegiados.length > 0
      && props.encomenda.Promotores
      && props.encomenda.Promotores.length > 0;
    const hasExistingTratamientoLPOPromotores = props.encomenda
      && props.encomenda.Expediente
      && props.encomenda.Expediente.length > 0
      && props.encomenda.Expediente[0].Hay_Tratamiento_LPO_Promotores;
      
    this.state = {
      encomenda: this.props.encomenda,
      isLoading: false,
      openVerification: false,
      openSubstitucionConfirmation: false,
      pendingFinalizeAction: null,
      verificationMessages: [],
      initialArchitectSignatures: initialArchitectSignatures,
      initialPromoterSignatures: initialPromoterSignatures,
      acceptTerm1: hasExistingAgents,
      acceptTerm2: hasExistingAgents,
      acceptTerm3: hasExistingAgents,
      acceptDataProtection: hasExistingTratamientoLPOPromotores
    }
  }

  getArchitectSignature = (architect) => {
    if (!architect) {
      return '';
    }

    const idColegiado = architect.Id_Colegiado != null ? architect.Id_Colegiado : '';
    const idSociedad = architect.Id_Sociedad != null ? architect.Id_Sociedad : 0;
    const nif = architect.Nif || '';
    return `${idColegiado}|${idSociedad}|${nif}`;
  }

  getArchitectSignatures = (encomenda) => {
    if (!encomenda || !encomenda.Colegiados) {
      return [];
    }
    return encomenda.Colegiados.map(this.getArchitectSignature);
  }

  getPromoterSignature = (promoter) => {
    if (!promoter) {
      return '';
    }

    const idEntidad = promoter.Id_Entidad != null ? promoter.Id_Entidad : '';
    const nif = promoter.Nif || '';
    const idTipoEntidad = promoter.Id_Tipo_Entidad != null ? promoter.Id_Tipo_Entidad : '';
    return `${idEntidad}|${nif}|${idTipoEntidad}`;
  }

  getPromoterSignatures = (encomenda) => {
    if (!encomenda || !encomenda.Promotores) {
      return [];
    }
    return encomenda.Promotores.map(this.getPromoterSignature);
  }

  getUsageTermsState = () => ([
    this.state.acceptTerm1,
    this.state.acceptTerm2,
    this.state.acceptTerm3
  ]);

  isSubstitucionExpediente = () => {
    const encomenda = this.state.encomenda;
    return encomenda
      && encomenda.Expediente
      && encomenda.Expediente.length > 0
      && encomenda.Expediente[0].Substitucion == 1;
  }



  //Funcion que consume la api para crear un nuevo trabajo encomenda
  async addTrabajoEncomenda(ignorarObservations = 1) {
    await this.setState({ isLoading: true });
    try {
      let encomenda = this.state.encomenda;
      let encomendaActual = encomenda.EncomendaActual && encomenda.EncomendaActual.length > 0
        ? encomenda.EncomendaActual[0] : null;
      const isSubstitucion = encomenda
        && encomenda.Expediente
        && encomenda.Expediente.length > 0
        && encomenda.Expediente[0].Substitucion == 1;



      if (encomendaActual) {
        let trabajoEncomenda = {
          Id_Tipo_Grupo_Tematico: encomendaActual.Id_Tipo_Grupo_Tematico,
          Id_Tipo_Autorizacion_Municipal: encomendaActual.Id_Tipo_Autorizacion_Municipal,
          Id_Tipo_Fase: 1,
          Id_Tipo_Trabajo: 219,/*219 significa que es una encomenda*/
          Id_Tipo_Tramite: 0, /*0 Visado normal*/
          Colegiados: encomenda.Colegiados,
          Promotores: encomenda.Promotores,
          Es_Trabajo_Encomenda_Substitucion: isSubstitucion ? 1 : 0,
          Antecedente: encomenda.Expediente[0].Antecedente,
          IgnorarObservaciones: ignorarObservations
        };

        //Obtener el id de expediente del estado de redux y llamar la funcion
        //postAddTrabajoEncomenda
        let currentExpId = encomendaActual.Id_Expediente;
        let result = await ApiCoag.expedientes.manageEncomenda(currentExpId, trabajoEncomenda);
        if (ignorarObservations === 0) {
          let messages = result.MensajesProcesado
            ? result.MensajesProcesado
            : result.MensajesProcesado
              ? result.MensajesProcesado
              : [];
          if (messages.length > 0 ) {
            this.setState({
              verificationMessages: messages,
              isLoading: false
            })
            this.openVerification(true); return;
          } else {
            if (result != 'ERROR2') //error que impide continuar
            {await this.setState({ isLoading: false });
            this.props.history.push(`/visualizar-expediente/${currentExpId}`);
            return;}
            else
            {}
          }
        }

        //Validación para continuar (si el resultado fue 200 se permite continuar)
        if ((result && result.MensajesProcesado && result.MensajesProcesado.length === 0)
          || result.status === 200) {
          let url = `/visualizar-expediente/${currentExpId}`;
          await this.setState({ isLoading: false });
          this.props.history.push(url);
          return true;
        }
        else {
          if (result.MensajesProcesado && result.MensajesProcesado.length > 0) {
            await this.setState({ isLoading: false });
            this.props.fetchErrorExpediente(result);
            return false;
          }
          else {
            if (result.response) {
              await this.setState({ isLoading: false });
              this.props.fetchErrorExpediente(result.response.data);
              return false;
            }
            else {
              await this.setState({ isLoading: false });
              this.props.fetchErrorExpediente(result.data);
              return false;
            }
          }
        }
      }

    } catch (e) {
      await this.setState({ isLoading: false });
      this.props.fetchErrorExpediente(formatMenssage(e.message));
    }

  }

  updateEncomenda(encomenda) {
    const initialArchitectSignatures = this.state.initialArchitectSignatures || [];
    const nextArchitectSignatures = this.getArchitectSignatures(encomenda);
    const hasDifferentArchitect = nextArchitectSignatures
      .some((signature) => !initialArchitectSignatures.includes(signature));
    const initialPromoterSignatures = this.state.initialPromoterSignatures || [];
    const nextPromoterSignatures = this.getPromoterSignatures(encomenda);
    const hasDifferentPromoter = nextPromoterSignatures
      .some((signature) => !initialPromoterSignatures.includes(signature));

    this.setState({
      encomenda: encomenda,
      ...(hasDifferentArchitect || hasDifferentPromoter
        ? {
          ...(hasDifferentArchitect ? {
          acceptTerm1: false,
          acceptTerm2: false,
          acceptTerm3: false
          } : {}),
          ...(hasDifferentPromoter ? {
          acceptDataProtection: false
          } : {})
        }
        : {})
    });
  }

  async crearTrabajo() {
    await this.setState({ isLoading: true });
    try {
      let encomenda = this.state.encomenda;
      let encomendaActual = encomenda.EncomendaActual && encomenda.EncomendaActual.length > 0
        ? encomenda.EncomendaActual[0] : null;
      const isSubstitucion = encomenda
        && encomenda.Expediente
        && encomenda.Expediente.length > 0
        && encomenda.Expediente[0].Substitucion == 1;

      if (encomendaActual) {
        let trabajoEncomenda = {
          Id_Tipo_Grupo_Tematico: encomendaActual.Id_Tipo_Grupo_Tematico,
          Id_Tipo_Autorizacion_Municipal: encomendaActual.Id_Tipo_Autorizacion_Municipal,
          Id_Tipo_Fase: 1,
          Id_Tipo_Trabajo: 219,
          Id_Tipo_Tramite: 0,
          Colegiados: encomenda.Colegiados,
          Promotores: encomenda.Promotores,
          Es_Trabajo_Encomenda_Substitucion: isSubstitucion ? 1 : 0,
          Antecedente: encomenda.Expediente[0].Antecedente,
          IgnorarObservaciones: 1
        };

        //Obtener el id de expediente del estado de redux y llamar la funcion
        let currentExpId = encomendaActual.Id_Expediente;
        let result = await ApiCoag.expedientes.manageEncomenda(currentExpId, trabajoEncomenda);
        if (result && await this.existEncomenda()) {
          this.props.history.push(`/crear-trabajo/${this.props.match.params.id}`);
          return;
        }
        else if (result.MensajesProcesado && result.MensajesProcesado.length > 0)
          this.props.fetchErrorExpediente(result);
        await this.setState({ isLoading: false });
      }
    } catch (e) {
      await this.setState({ isLoading: false });
      this.props.fetchErrorExpediente(formatMenssage(e.message));
    }
  }

  async existEncomenda() {
    let result = await ApiCoag.expedientes.getEncomendaActual(this.props.match.params.id);
    if (result)
      return result.EncomendaActual.length > 0;
    return false;
  }

  handleClose = () => {
    this.setState({ isLoading: false });
  };

  openVerification = (open) => {
    this.setState({ openVerification: open });
  }

  openSubstitucionConfirmation = (pendingFinalizeAction) => {
    this.setState({
      openSubstitucionConfirmation: true,
      pendingFinalizeAction: pendingFinalizeAction
    });
  }

  closeSubstitucionConfirmation = () => {
    this.setState({
      openSubstitucionConfirmation: false,
      pendingFinalizeAction: null
    });
  }

  acceptSubstitucionConfirmation = async () => {
    const pendingFinalizeAction = this.state.pendingFinalizeAction;
    this.closeSubstitucionConfirmation();

    if (pendingFinalizeAction === 'crear') {
      await this.crearTrabajo();
      return;
    }

    if (pendingFinalizeAction === 'finalizar') {
      await this.addTrabajoEncomenda(0);
    }
  }

  handlePreFinalizeAction = async (pendingFinalizeAction) => {
    if (this.isSubstitucionExpediente()) {
      this.openSubstitucionConfirmation(pendingFinalizeAction);
      return;
    }

    if (pendingFinalizeAction === 'crear') {
      await this.crearTrabajo();
      return;
    }

    if (pendingFinalizeAction === 'finalizar') {
      await this.addTrabajoEncomenda(0);
    }
  }

  renderVerification() {
    return (
      <div>
        <Dialog
          open={true}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">
            <Translate id="languages.generalButton.mensaje" />
          </DialogTitle>
          <DialogContent>
            {this.state.verificationMessages.map((message, index) => {
              return <DialogContentText id="alert-dialog-description">
                <ReactQuill key={index} value={message.Mensaje} readOnly theme='bubble' />
              </DialogContentText>
            })}

            {this.state.verificationMessages.every(x => x.IdTipo === 1)
              && <Typography className="ml-1 pl-2" component="h2" variant="display1" gutterBottom style={{ fontSize: "1rem" }}>
                <Translate id="languages.messages.aceptConcents" />
              </Typography>}
          </DialogContent>

          {this.state.verificationMessages.every(x => x.IdTipo === 1)
            ? <DialogActions>
              <Button size="small" className="mx-2"
                onClick={() => this.openVerification(false)}>
                <Translate id="languages.generalButton.cancel" />
              </Button>
              <Button variant="contained" size="small" className="mx-2" color="primary"
                onClick={() => {
                  this.openVerification(false);
                  this.addTrabajoEncomenda(1);
                }}>
                <Translate id="languages.generalButton.yes" />
              </Button>
              <Button variant="contained" size="small" className="mx-2" color="primary"
                onClick={() => {
                  this.openVerification(false);
                  this.props.history.push(`/visualizar-expediente/${this.props.match.params.id}`);
                }}>
                <Translate id="languages.generalButton.no" />
              </Button>
            </DialogActions>
            : <DialogActions>
              <Button size="small" className="mx-2"
                onClick={() => this.openVerification(false)}>
                <Translate id="languages.generalButton.cancel" />
              </Button>
              <Button variant="contained" size="small" className="mx-2" color="primary"
                onClick={() => {
                  this.openVerification(false);
                  this.props.history.push(`/visualizar-expediente/${this.props.match.params.id}`);
                }}>
                <Translate id="languages.generalButton.goToExpedient" />
              </Button>
            </DialogActions>}
        </Dialog>
      </div>
    );
  }

  render() {
    let { classes } = this.props;
    const hasArchitects = this.state.encomenda
      && this.state.encomenda.Colegiados
      && this.state.encomenda.Colegiados.length > 0;
    const hasPromoters = this.state.encomenda
      && this.state.encomenda.Promotores
      && this.state.encomenda.Promotores.length > 0;
    const hasArchitectsAndPromoters = hasArchitects && hasPromoters;
    const usageTerms = this.getUsageTermsState();
    const allUsageTermsAccepted = usageTerms.every(Boolean);
    const hasExistingTratamientoLPOPromotores = this.state.encomenda
      && this.state.encomenda.Expediente
      && this.state.encomenda.Expediente.length > 0
      && this.state.encomenda.Expediente[0].Hay_Tratamiento_LPO_Promotores > 0;

    const canFinishWorkflow = hasArchitects
      && hasPromoters
      && allUsageTermsAccepted
      && (this.state.acceptDataProtection || hasExistingTratamientoLPOPromotores);
  

    return (
      <Container className={"margin-container"}>
        <Grid item xs={12} className="min-height-panel">
          <ExpansionPanel expanded={true}>
            <ExpansionPanelSummary style={{ minHeight: 48, height: 48 }} /*48;48 */
              className={"title-main-panel"}>
              <div>
                <Translate id="languages.agentes.agentSectionTitle" />
              </div>
            </ExpansionPanelSummary>

            <ExpansionPanelDetails>
              <Grid container spacing={24}>
                <Grid item md={6} xs={12} className={"margin-panel"}>
                  <Arquitecto currentExpediente={this.props.currentExpediente} classes={this.styles} encomenda={this.state.encomenda} updateEncomenda={(encomenda) => this.updateEncomenda(encomenda)} />
                </Grid>
                <Grid item md={6} xs={12} className={"margin-panel"}>
                  <Promotores encomenda={this.state.encomenda} updateEncomenda={(encomenda) => this.updateEncomenda(encomenda)} />
                </Grid>
              </Grid>
            </ExpansionPanelDetails>

            {(hasArchitectsAndPromoters && (!allUsageTermsAccepted || !this.state.acceptDataProtection)) && 

               <ExpansionPanelDetails className="pt-0 pb-0">
                <Grid container spacing={24} className="w-100">
                  <Grid item xs={12} className="pt-3">
                <Typography variant="caption" color="error" className="ml-0">
                  <Translate id="languages.agentes.termsValidation" /> *
                </Typography>
                  </Grid>
                </Grid>
              </ExpansionPanelDetails>            }

            {hasArchitectsAndPromoters &&
              <ExpansionPanelDetails className="pt-0 pb-2">
                <Grid container spacing={24} className="w-100">
                  <Grid item xs={12} className="pt-3">

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.acceptTerm1}
                          onChange={(event) => this.setState({ acceptTerm1: event.target.checked })}
                          color="primary" />
                      }
                      label={<Translate id="languages.agentes.conditionTermn1" />} />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.acceptTerm2}
                          onChange={(event) => this.setState({ acceptTerm2: event.target.checked })}
                          color="primary" />
                      }
                      label={<Translate id="languages.agentes.conditionTermn2" />} />

                       <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.acceptTerm3}
                          onChange={(event) => this.setState({ acceptTerm3: event.target.checked })}
                          color="primary" />
                      }
                      label={<Translate id="languages.agentes.conditionTermn3" />} />
                  </Grid>
                </Grid>
              </ExpansionPanelDetails>
            }

             {hasArchitectsAndPromoters && !hasExistingTratamientoLPOPromotores &&
              <ExpansionPanelDetails className="pt-0 pb-3">
                <Grid container spacing={24} className="w-100">
                  <Grid item xs={12} className="pt-3">

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.acceptDataProtection}
                          onChange={(event) => this.setState({ acceptDataProtection: event.target.checked })}
                          color="primary" />
                      }
                      label={<Translate id="languages.agentes.conditionTermLPO" />} />
                  </Grid>
                </Grid>
              </ExpansionPanelDetails>
            }
          </ExpansionPanel>
        </Grid>
        <Grid item xs={12} className="py-2">
          <Button variant="contained" size="small" color="primary" className="float-right px-3 ml-2"
            disabled={!canFinishWorkflow}
            onClick={() => this.handlePreFinalizeAction('crear')}>
            <Translate id="languages.generalButton.crearTrabajoEnc" />
          </Button>
          <Button variant="contained" size="small" color="primary" className="float-right px-3"
            disabled={!canFinishWorkflow}
            onClick={() => this.handlePreFinalizeAction('finalizar')}>
            <Translate id="languages.generalButton.finalizarEnc" />
          </Button>
          <Button color="primary" size="small" className="float-right mx-2"
            onClick={() => {
              this.props.history.push(`/visualizar-expediente/${this.props.match.params.id}`);
            }}>
            <Translate id="languages.generalButton.cancel" /><Close className={"right-icon-button"} />
          </Button>
          <Button color="primary" size="small" className="float-left px-4" onClick={() => { this.props.handleBack() }}>
            <Translate id="languages.generalButton.volver" />
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Dialog
            disableBackdropClick
            disableEscapeKeyDown
            open={this.state.isLoading}
            onClose={this.handleClose}
          >
            <DialogContent>
              <CircularProgress />
            </DialogContent>
          </Dialog>
        </Grid>

        <Grid item xs={12}>
          {this.state.openVerification && this.renderVerification()}
        </Grid>

        <Confirmation openConfirmation={this.state.openSubstitucionConfirmation}
          title={'Expediente de substitución'}
          confirmationMessage={<Translate id="languages.messages.expedienteSubstitucion" />}
          extraClassName="confirmation-quill--substitucion"
          acceptCancel={true}
          aceptConfirmation={this.acceptSubstitucionConfirmation}
          declineConfirmation={this.closeSubstitucionConfirmation}
          botonConfirmarTexto={'Continuar'}
          maxWidth={"md"}
          confirmationCheckItem={true}
          confirmationCheckItemText={'ENTERADO'}
        />
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedColegiados: state.trabajos.agentesTrabajoSelected ? state.trabajos.agentesTrabajoSelected : [],
  selectedPromoters: state.expedientes.promotores,
  loguedUser: state.user.DatosUsuarioValidado,
  comunicacionEncargo: state.trabajos.comunicacionEncargo,
  expedientes: state.expedientes,
  funcionesTipologicas: state.trabajos.funcionesTipologia.data ? state.trabajos.funcionesTipologia.data.Tipos_Trabajos_Tunciones : [],
  currentExpediente: state.expedientes.ExpedientNew ? state.expedientes.ExpedientNew : {},
  state: state
})

const mapDispatchToProps = {
  postAddTrabajoEncomenda: postAddTrabajoEncomenda,
  fetchErrorExpediente
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Agentes));